<template>
  <label
    class="free-switch flex items-center justify-between"
    :class="{ 'text-situational-grey': disabled }"
  >
    <input
      :checked="isChecked"
      :disabled="disabled"
      type="checkbox"
      class="free-switch__input hidden"
      @change="onInputChange"
    />
    <div class="free-switch__background relative rounded-[48px]"></div>
    <slot name="labelText" />
  </label>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { isNil } from 'lodash-es';

  const props = withDefaults(
    defineProps<{
      disabled?: boolean;
      /** @deprecated Prefer v-model */
      checked?: boolean;
      /** Used with v-model */
      modelValue?: boolean;
    }>(),
    {
      disabled: false,
      checked: false,
      modelValue: undefined,
    },
  );

  const emit = defineEmits<{
    (e: 'update:modelValue', value: boolean): void;
    (e: 'onChange'): void;
  }>();

  const isChecked = computed(() =>
    !isNil(props.modelValue) ? props.modelValue : props.checked,
  );

  function onInputChange() {
    const next = !isChecked.value;
    emit('update:modelValue', next);
    emit('onChange');
  }
</script>

<style scoped>
  .free-switch {
    /* value should be px */
    --pointer-margin: 2px;
    --pointer-size: 27px;
    --switch-height: 32px;
    --switch-width: 52px;
    --pointer-checked-position: calc(
      var(--pointer-size) + var(--pointer-margin)
    );
    --background-checked-color: theme('colors.green.500');
    --background-color: theme('colors.situational.lightgrey');
    --pointer-color: theme('colors.white');
    --pointer-margin: 2px;
  }

  .free-switch__input:checked + .free-switch__background::after {
    left: calc(100% - var(--pointer-checked-position));
  }

  .free-switch__input:checked + .free-switch__background {
    background: var(--background-checked-color);
  }

  .free-switch__background {
    background: var(--background-color);
    transition: background-color 0.2s;
    width: var(--switch-width);
    height: var(--switch-height);
  }

  .free-switch__background::after {
    @apply absolute bottom-0 top-0 my-auto rounded-full;
    background: var(--pointer-color);
    transition:
      opacity 0.2s,
      left 0.2s;
    transition-delay: 0.1s;
    left: var(--pointer-margin);
    width: var(--pointer-size);
    height: var(--pointer-size);
    box-shadow:
      0px 3px 8px rgba(0, 0, 0, 0.15),
      0px 3px 1px rgba(0, 0, 0, 0.06);
    content: '';
  }
</style>
